export enum QueryNames {
  GET_SIZE = 'GET SIZE',
  GET_SIZES = 'GET SIZES',

  GET_PRODUCT = 'GET PRODUCT',
  GET_PRODUCTS = 'GET PRODUCTS',

  GET_ARCHIVED_PRODUCT = 'GET ARCHIVED PRODUCT',
  GET_ARCHIVED_PRODUCTS = 'GET ARCHIVED PRODUCTS',

  GET_VARIANT = 'GET VARIANT',
  GET_VARIANTS = 'GET VARIANTS',

  GET_COLOR = 'GET COLOR',
  GET_COLORS = 'GET COLORS',

  GET_ACTIVITY = 'GET ACTIVITY',
  GET_ACTIVITIES = 'GET ACTIVITIES',
  GET_ACTIVITIES_BY_CATEGORY_ID = 'GET ACTIVITIES_BY_CATEGORY_ID',

  GET_COMPETITION = 'GET COMPETITION',
  GET_COMPETITIONS = 'GET COMPETITIONS',

  GET_USERS = 'GET USERS',
  GET_PAGINATED_USERS = 'GET PAGINATED USERS',
  GET_USER = 'GET USER',
  GET_FIRED_USERS = 'GET FIRED USERS',
  GET_DELETED_USERS = 'GET DELETED USERS',

  GET_USER_ACTIVITIES = 'GET_USER_ACTIVITIES',
  GET_ALL_USER_ACTIVITIES = 'GET_ALL_USER_ACTIVITIES',
  GET_PENDING_USER_ACTIVITIES = 'GET_PENDING_USER_ACTIVITIES',

  GET_CART_PRODUCTS = 'GET_CART_PRODUCTS',

  GET_WISHLIST_PRODUCTS = 'GET_WISHLIST_PRODUCTS',

  GET_USER_AVATAR = 'GET_USER_AVATAR',

  GET_USER_STATISTICS = 'GET_USER_STATISTICS',

  GET_NOTIFICATIONS = 'GET_NOTIFICATIONS',

  GET_USER_ORDERS = 'GET_USER_ORDERS',

  GET_USER_GIFTS = 'GET_USER_GIFTS',

  GET_ACTIVITY_CATEGORIES = 'GET_ACTIVITY_CATEGORIES',
  GET_ACTIVITY_CATEGORY = 'GET_ACTIVITY_CATEGORY',

  GET_USER_COMPETITIONS = 'GET_USER_COMPETITIONS',

  GET_SIZE_TABLES = 'GET_SIZE_TABLES',
  GET_SIZE_TABLE = 'GET_SIZE_TABLE',

  GET_ORDERS = 'GET_ORDERS',
  GET_NEW_ORDERS = 'GET_NEW_ORDERS',

  GET_VARIANTS_STOCK = 'GET VARIANTS STOCK',

  GET_ACHIEVEMENTS = 'GET_ACHIEVEMENTS',
  GET_USER_LEVEL = 'GET_USER_LEVEL',

  GET_CANDIDATE = 'GET_CANDIDATE',
  GET_CANDIDATES = 'GET_CANDIDATES',

  GET_VACANCY = 'GET_VACANCY',
  GET_VACANCIES = 'GET_VACANCIES',

  GET_PIXELS_HISTORY = 'GET_PIXELS_HISTORY',

  CANDIDATE_ACTIONS = 'CANDIDATE_ACTIONS',

  GET_ACTION_NAME = 'GET_ACTION_NAME',
  GET_ACTION_NAMES = 'GET_ACTION_NAMES',

  GET_USER_PREFERENCES = 'GET_USER_PREFERENCES',
  GET_USER_RECIPIENT = 'GET_USER_RECIPIENT',
}
